import React from 'react'
import { Helmet } from 'react-helmet'
import About from './components/about/About'
import Nav from './components/nav/Nav'
import Contact from './components/contact/Contact'
import Experience from './components/experience/Experience'
import Footer from './components/footer/Footer'
import Header from './components/header/Header'
import Portfolio from './components/portfolio/Portfolio'
import Services from './components/services/Services'
import Icon from './assets/images/icon.png'
import Clarity from '@microsoft/clarity';



const App = () => {
  const projectId = "pwi5r7309v"

  Clarity.init(projectId);
  return (
    <>
      <Helmet>
        <title>Ravi Chaudhary | Full Stack Developer</title>
        <link rel="shortcut icon" href={Icon} type="image/x-icon" />
        <link rel="icon" href={Icon} type="image/x-icon" />
        <meta name="description" content="Ravi Chaudhary is a Full Stack Developer specializing in web development, creating responsive and user-friendly applications." />
        <meta name="keywords" content="Ravi Chaudhary, Full Stack Developer, Web Developer, React Developer, JavaScript Developer" />
        <meta name="author" content="Ravi Chaudhary" />
        <meta property="og:title" content="Ravi Chaudhary | Full Stack Developer" />
        <meta property="og:description" content="Full Stack Developer specializing in web development, creating responsive and user-friendly applications." />
        <meta property="og:type" content="website" />
      </Helmet>

    
    {/* <AnimatedCursor
    
      innerSize={12}
      outerSize={12}
      color='14, 230, 183'
      outerAlpha={0.2}
      innerScale={0.7}
      outerScale={5}
      clickables={[
        'a',
        'input[type="text"]',
        'input[type="email"]',
        'input[type="number"]',
        'input[type="submit"]',
        'input[type="image"]',
        'label[for]',
        'select',
        'textarea',
        'button',
        '.link'
      ]}
     /> */}
    <Header />
    <Nav />
    <About />
    <Experience />
    <Services />
    {/* <Portfolio /> */}
    {/* <Testimonials /> */}
    <Contact />
    <Footer />
    </>
  )
}

export default App